// Memberships & Communities Tour
// Courses, communities, offers, client portal and certificates
// Selector policy: step 1 pins to the LIVE-VERIFIED sidebar id (#sb_memberships); the teaching steps are
// deliberate centered cards — no guessed element selectors (a wrong spotlight is worse than none).

export const membershipsTour = {
  id: 'memberships',
  name: 'Memberships & Communities Tour',
  displayName: 'Sell Courses & Build Community',
  description: 'Courses, communities, offers, client portal and certificates',
  estimatedDuration: '5 minutes',
  category: 'feature',
  autoStart: false,
  prerequisiteTours: ['ftux'],

  config: {
    animate: true,
    overlayOpacity: 0.75,
    smoothScroll: true,
    allowClose: true,
    showProgress: true
  },

  steps: [
    {
      element: '#sb_memberships',
      popover: {
        title: "🎓 Welcome to Memberships",
        description: `
          Turn what you know into something you sell: **courses**, **communities**, and a **client portal** your customers log into. All in one place.
        `,
        side: 'right',
        align: 'center'
      }
    },

    {
      popover: {
        title: "📚 Courses",
        description: `
          Build a **course** as modules and lessons — video, text, downloads, quizzes. Drip content on a schedule or unlock it all at once.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🏷️ Offers",
        description: `
          A course is content; an **offer** is how it sells. Set the price — one-time, subscription, or free — and the offer handles enrollment and access automatically.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "👥 Communities & Groups",
        description: `
          Add a **community** so members talk to each other, not just to your content. Discussions, posts, and channels keep people engaged and renewing.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🚪 Client Portal",
        description: `
          The **client portal** is your customers' front door: their courses, community, documents, and invoices behind one branded login.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "📱 Branded Mobile App",
        description: `
          Take it further with a **branded mobile app** — your courses and community in an app store listing with your name and logo on it.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🏅 Certificates & Badges",
        description: `
          Reward completion with a **certificate** or **badge**. Learners get proof, and you get social proof every time they share it.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "📈 Analytics",
        description: `
          **Analytics** shows who enrolled, who is progressing, and where people stall — so you fix the lesson that loses them.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🎉 You Are In Business",
        description: `
          You can now:

✅ Build courses with modules and lessons
✅ Price them with offers
✅ Add a community and a branded portal
✅ Certify completion and track progress

**Next:** outline one course, publish a single lesson, and attach an offer.
        `,
        side: 'over',
        align: 'center',
        showButtons: ['close'],
        doneBtnText: 'Done →'
      }
    }
  ]
};
